import { initAnalytics } from './index';

initAnalytics();
